export enum EPropertyCriteriaSort {
  CREATED = 'created',
  DISTANCE = 'distance',
  RANKING = 'ranking',
  CHEAP = 'cheap',
  EXPENSIVE = 'expensive',
  LARGE = 'large',
  SMALL = 'small',
  OLDEST = 'oldest',
}

export enum ESearchLevel {
  STATE = 'state',
  MUNICIPALITY = 'municipality',
  NEIGHBORHOOD = 'neighborhood',
  BlOCK = 'block',
  PROPERTY = 'property',
}

export enum EOpportunityCriteria {
  BUY_TO_LIVE = 'for-sale-to-live',
  BUY_TO_REMODEL = 'for-sale-for-flipping',
  BUY_TO_RENT = 'for-sale-per-caprate',
  PUBLISHED_IN_LAST_7_DAYS = 'for-rent-last-7-days',
  THAT_ARE_ABOUT_TO_BE_RENTED = 'for-rent-soon-to-be',
  AT_GREAT_RENTAL_PRICE = 'for-rent-price-opportunity',
}
